import getPublicUrl from './getPublicUrl';

export default function isInternalLink(content?: string | null) {
  const link = getPublicUrl() ?? '';
  return content?.includes(link);
}
